import { useState } from 'react';

import { Button, Select, SimpleGrid, TextInput } from '@mantine/core';

import { Component, ComponentType, SlackChannel } from 'models';

import { SlackNotificationService } from 'services/SlackNotificationService';

export type NonDcideComponent = Component['compatibleWithPlaceholders'][number];

const AddNonDcideComponentForm = ({
    onAdd,
    compatibleWith,
}: {
    onAdd: (component: NonDcideComponent) => void;
    compatibleWith?: string;
}) => {
    const [manufacturer, setManufacturer] = useState('');
    const [productIdentifier, setProductIdentifier] = useState('');
    const [componentType, setComponentType] = useState<ComponentType | null>(null);
    const [email, setEmail] = useState('');

    return (
        <SimpleGrid spacing={4} cols={{ base: 1, md: 5 }} style={{ alignItems: 'end' }}>
            <TextInput
                label="Manufacturer name"
                value={manufacturer}
                onChange={(event) => setManufacturer(event.target.value)}
            />
            <TextInput
                label="Part number"
                value={productIdentifier}
                onChange={(event) => setProductIdentifier(event.target.value)}
            />
            <Select
                searchable
                label="Component type"
                placeholder="Select type"
                data={ComponentType.options}
                value={componentType}
                onChange={(value) => setComponentType(value as ComponentType)}
            />
            <TextInput
                label="Contact email (optional)"
                description="So we can follow up, for lead management or technical support."
                value={email}
                onChange={(event) => setEmail(event.target.value)}
            />

            <Button
                onClick={() => {
                    if (!componentType) return;

                    onAdd({ manufacturer, productIdentifier, componentType });

                    if (email) {
                        SlackNotificationService.send(
                            [
                                '📨 Someone has flagged a compatible product, which does not exist in our database. Please reach out to the following person to incentivize them to upload their product.',
                                `Manufacturer: ${manufacturer}`,
                                `Product ID: ${productIdentifier}`,
                                `Email: ${email}`,
                                `Compatible with product id: ${compatibleWith || 'unknown'}`,
                            ].join('\n'),
                            SlackChannel.OEM,
                        );
                    }

                    setManufacturer('');
                    setProductIdentifier('');
                    setEmail('');
                }}
                disabled={!manufacturer || !productIdentifier || !componentType}
            >
                Add as compatible
            </Button>
        </SimpleGrid>
    );
};

export { AddNonDcideComponentForm };
